import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Observable, tap } from 'rxjs';

interface AudioState {
  userMute: boolean;
  mute: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class AudioService extends ComponentStore<AudioState> {
  userMute$: Observable<boolean> = this.select((s) => s.userMute);

  mute$: Observable<boolean> = this.select((s) => s.mute);

  setButtonClickEvent = this.effect((click$: Observable<Event>) => {
    return click$.pipe(
      tap(() => {
        const userMute = !this.get((s) => s.userMute);
        this.setState((s) => {
          return {
            ...s,
            userMute,
            mute: userMute,
          };
        });
      })
    );
  });

  constructor() {
    super({ mute: false, userMute: false });
  }

  set mute(mute: boolean) {
    this.patchState({ mute });
  }

  get mute(): boolean {
    return this.get((s) => s.mute);
  }

  set userMute(userMute: boolean) {
    this.patchState({ userMute, mute: userMute });
  }

  get userMute(): boolean {
    return this.get((s) => s.userMute);
  }
}
